var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-bar-box"},[_c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"inner",style:(`width: ${_vm.percentage}%`)})]),_c('p',[(_vm.text)?_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))]):_vm._e(),_vm._v("("+_vm._s(_vm.percentage)+"%)")])])
}
var staticRenderFns = []

export { render, staticRenderFns }